import { IconButton } from '@fullscreendigital/carrefour-dex-fe'
import { AddActionIcon } from 'icons'

const AddButton = ({ onClick }) => (
  <IconButton onClick={onClick} label="Add">
    <AddActionIcon />
  </IconButton>
)

export default AddButton
